export const RESUME_DRAFT_KEY = "resume_draft" as const;
